import React from "react";
import { getImageUrl } from "../utils.js";

export default class Grid extends React.Component {
  constructor(props) {
    super(props);
    this.onImageClick = this.onImageClick.bind(this);
  }

  onImageClick(index) {
    this.props.onImageClick(index);
  }
  renderImageItem(image, index, onClick) {
    const { farm, server, id, secret } = image;
    return (
      <figure
        key={index}
        className="masonry-brick masonry-brick--h"
        onClick={() => onClick(index)}
      >
        <img
          key={index}
          className="masonry-img"
          src={getImageUrl(farm, server, id, secret)}
          alt=""
        />
      </figure>
    );
  }

  render() {
    return (
      <div className="row columns">
        <div className="column is-full">
          <div className="masonry masonry--h">
            {this.props.images.map((image, index) =>
              this.renderImageItem(image, index, this.onImageClick)
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grid.js